import { Component } from '@angular/core';

@Component({
  selector: 'syn-internal-error',
  templateUrl: './internal-error.component.html',
  styleUrls: ['./internal-error.component.scss'],
})
export class InternalErrorComponent {
  constructor() {}
}
